module.exports = __webpack_public_path__ + "static/landingbuilder-5-49318718c6a459402d90e8aff85f4561.png";